import React, { useContext, useEffect } from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { ListItem } from 'react-native-elements';
import { TouchableOpacity } from 'react-native-gesture-handler';

import { Context as NewsContext } from '../context/NewsContext';
import { deviceWidth } from '../helpers/deviceHelper';
import { dateElementsExtractor } from '../helpers/dateHelper';
import Loading from '../components/Loading';

const styles = StyleSheet.create({
  sectionTitleContainer: {
    // borderColor: 'red',
    // borderWidth: 3,
    height: deviceWidth * 0.3,
    backgroundColor: 'white',
    padding: deviceWidth * 0.05,
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionTitle: {
    fontFamily: 'MPLUS1p_400Regular',
    fontSize: 30,
  },
  newsDate: {
    fontFamily: 'MPLUS1p_300Light',
  },
  newsText: {
    fontFamily: 'MPLUS1p_300Light',
  },
});
export default function NewsContainer() {
  const { state, fetchNews } = useContext(NewsContext);

  useEffect(() => {
    fetchNews();
  }, []);

  return (
    <View>
      <View style={styles.sectionTitleContainer}>
        <Text style={styles.sectionTitle}>おしらせ</Text>
      </View>
      {state.length !== 0 ? (
        state.map(({ content }) => {
          const { year, month, day } = dateElementsExtractor(
            new Date(content.newsDate)
          );
          return (
            <TouchableOpacity key={content.newsTitle}>
              <ListItem bottomDivider>
                <ListItem.Content>
                  <ListItem.Subtitle
                    style={styles.newsDate}
                  >{`${year}/${month}/${day}`}</ListItem.Subtitle>
                  <ListItem.Title style={styles.newsText}>
                    {content.newsTitle}
                  </ListItem.Title>
                </ListItem.Content>
              </ListItem>
            </TouchableOpacity>
          );
        })
      ) : (
        <Loading />
      )}
    </View>
  );
}
